import { createStorageService } from './create-storage-service.ts';

export const localStorageService = createStorageService({
  getStorage: () => {
    localStorage.setItem(`test`, `1`);
    localStorage.removeItem(`test`);
    return localStorage;
  },
});
